import { z } from 'zod';

export type Literal = string | number | boolean | null | undefined;
export type Json = Literal | { [key: string]: Json } | Json[];

// Dynamic shorthand pattern for relative date ranges (e.g., "21d", "3w", "6m", "2q", "2y")
// Also supports "complete" prefix: "c2w" = last 2 complete weeks
const dynamicShorthandPattern = /^c?\d+[dwmqy]$/;

export const timeRange = z.union([
  z.literal('custom'),
  z.literal('today'),
  z.literal('tomorrow'),
  z.literal('yesterday'),
  z.literal('7d'),
  z.literal('30d'),
  z.literal('90d'),
  z.literal('1y'),
  z.literal('wtd'),
  z.literal('nextweek'),
  z.literal('prevweek'),
  z.literal('ytd'),
  z.literal('mtd'),
  z.literal('nextmonth'),
  z.literal('prevmonth'),
  z.literal('qtd'),
  z.literal('prevquarter'),
  z.literal('prevyear'),
  // Dynamic shorthand patterns like "21d", "3w", "6m", "2q", "2y"
  z.string().refine((val) => dynamicShorthandPattern.test(val), {
    message: 'Must be a valid shorthand pattern (e.g., 21d, 3w, 6m, 2q, 2y)',
  }),
]);
export type TimeRange = z.infer<typeof timeRange>;

// Check if a TimeRange is a dynamic shorthand pattern
export const isDynamicShorthand = (range: string): boolean => dynamicShorthandPattern.test(range);

// Check if a TimeRange is a "complete" shorthand pattern (e.g., "c2w", "c6m")
export const isCompleteShorthand = (range: string): boolean => /^c\d+[dwmqy]$/.test(range);

export enum TimePrecision {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export const timePrecision = z.enum(TimePrecision);
